export enum YesNoBoth {
  Yes = 'Yes',
  No = 'No',
  Both = 'Both',
}
